
import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { FileCopySharp } from '@material-ui/icons';
//iconos
import { Add } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { TextField } from '@material-ui/core';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import { useParams } from 'react-router-dom';

//servicios
import { wsGet, wsUpdate, wsFindBy } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import moment from 'moment';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Periodo', accessor: 'Periodo'},
  { Header: 'Código de producto', accessor: 'ItemCode'},
  { Header: 'Nombre de producto', accessor: 'ItemName'},
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function Colgate(props) {
  const { id } = useParams();
  const classes = useStyles();
  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [dataLoading, setDataLoading] = useState(false);
  const [cuotas, setCuotas] = useState([]);
  const [cuotasDetail, setCuotasDetail] = useState([]);
  
  async function getCuota(idCuotas) {
    setDataLoading(true);
    let response = await wsGet('sale/cuota-grupo-periodo', idCuotas);
    setDataLoading(false);
    if (response.success) {
      setCuotas(response.data);
    }
  }

  async function listCuotaDetail() {
    setDataLoading(true);
    let response = await wsFindBy('sale/cuota-grupo-detalle-periodo', { Periodo: moment(cuotas.Periodo).format('YYYY-MM'), cuota_grupo_periodo_id: id });
    setDataLoading(false);
    if (response.success) setCuotasDetail(response.data);
  }

  useEffect(() => {
    getCuota(id);
  }, []);

  useEffect(() => {
    if (cuotas && cuotas.Periodo) {
      listCuotaDetail();
    }
  }, [cuotas]);

  return (
    <GridContainer>
      <Toasty action={notify} />
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={listCuotaDetail}
          id={id}
        />
      ) : undefined}

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_STORE}
              component={
                <CardIcon color="primary">
                  <FileCopySharp style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado Detallado de Cuota de Grupo por Periodo 
            <span style={{ fontSize: '14px' }}>
              <b>{` (${cuotas.Periodo || ''} - ${cuotas.description || ''})`}</b>
            </span>
            {dataLoading && <LoadingSpinner />}
            </h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="cuotas_grupo_colgate_periodo_detalle"
              formatDate="DD-MM-YYYY"
              columns={columns}
              data={cuotasDetail.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard
                        permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_DELETED}
                      >
                        <ButtonDelete
                          entity="sale/cuota-grupo-detalle-periodo"
                          id={item.id}
                          
                          reload={() => {
                            setDataLoading(true);
                            listCuotaDetail().then(() => setDataLoading(false));
                        }}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  Periodo: item.Periodo,
                  ItemCode: item.product?.ItemCode,
                  ItemName: item.product?.ItemName,
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
